import { useReturnsExperience } from "../../experience/use-returns-experience";
import { HOME_PAGES } from "../sources/home-sources";
import type { HomeRecordType } from "../sources/record-home-source";
import { resolveRecordHomeExperience } from "./record-home-experience";

/** The returns experience, narrowed to whether this type's home page exists yet. */
export function useRecordHomeExperience(type: HomeRecordType): {
  useNewUi: boolean;
} {
  const { useNewUi } = useReturnsExperience();
  return resolveRecordHomeExperience({
    experienceOn: useNewUi,
    sourceEnabled: HOME_PAGES[type] !== undefined,
  });
}
